export const APP_CONFIG = {
  appName: 'Sigedon Cataloger',
  appDescription: 'AI-Powered Antique Evaluation Platform',
  companyName: 'Sigedon DOO',
};

export const GEMINI_API_KEY = 'AIzaSyDZkgO9fE7AGImYWKtol_ycAqj5xa0t2Wk';

export const GEMINI_MODELS = {
  'gemini-2.5-pro': 'https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-pro:generateContent',
  'gemini-2.5-flash': 'https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash:generateContent',
  'gemini-3.1-pro-preview': 'https://generativelanguage.googleapis.com/v1beta/models/gemini-3.1-pro-preview:generateContent',
};

export type GeminiModelName = 'gemini-2.0-flash' | 'gemini-2.5-pro' | 'gemini-2.5-flash' | 'gemini-3.1-pro-preview';

export const EBAY_OAUTH_AUTHORIZE_URL =
  process.env.REACT_APP_EBAY_OAUTH_AUTHORIZE_URL || '';

export default APP_CONFIG;
